import React from "react";

import {Link} from "react-router-dom";
import IconTooltip from "ui/Tooltip/IconTooltip";

export const defaultSearchBarStyle = {
    height: "30px",
    width: "25vw",
    margin: "20px",
    float: 'right',
    backgroundColor: "#edf4f9"
} ;

export const defaultTopLeftCellStyle = "5px 0px 0px 0px" ;
export const defaultTopRightCellStyle = "0px 5px 0px 0px" ;

export const defaultTableHeaderStyles = {
    backgroundColor: "#ECF6FD",
    textAlign: "left",
    border: "0",
    fontSize: "14px"
} ;

export const defaultPaginationOptions = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    showTotal: true,
    className: "neil-pager"
};

export const defaultTableOptions = {
striped: true ,
bordered: false,
hover: true,
rowStyle: {
    color: "#605F5E",
    textAlign: "left",
    fontSize: "14px",
    margin: "10px"
}} ;

const defaultIconStyle = { marginLeft: '0px', marginRight: '0px', fontWeight: 'bold', lineHeight: '1.1rem', fontSize: '1.2rem' } ;

export const customHeaderStyle = (headerStyles, column, colIndex) => {

    const name = column.dataField ;

    let style = headerStyles.default ;

    if ( headerStyles[name] !== undefined )
    {
        style = { ...style, ...headerStyles[name]} ;
    }

    return style ;
};



export const TableActionIconGeneric = ( props ) =>
{
    const color = props.color === undefined ? "var(--s360-icon-blue)" : props.color ;
    const style = props.style === undefined ? defaultIconStyle : { ...defaultIconStyle,  ...props.style } ;

    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={style} placement='top' text={props.text} icon={props.icon} color={color}/>
    }
    else if ( props.to !== undefined && props.to !== null )
    {
        return <Link to={props.to}><IconTooltip placement='top' text={props.text} style={style} icon={props.icon} color={color}/></Link>
    }
    else if ( props.href !== undefined )
    {
        const href = props.href === undefined || props.href === null ? '#' : props.href ;
        const target = props.target === undefined || props.target === null ? '_blank' : props.target;

        return  <a href={href} target={target}><IconTooltip placement='top' text={props.text} style={style} icon={props.icon} color={color}/></a>
    }
    else
    {
        return <IconTooltip style={style} placement='top' text={props.text} icon={props.icon} color={color}/>
    }
}

export const TableActionIconEdit = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: '10px'}}
                            placement='top' text={props.text} icon="icon-edit" color="var(--s360-icon-blue)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={url} style={{marginRight: '10px'}}><IconTooltip placement='top' text={props.text}
                                                                              icon="icon-edit"
                                                                              color="var(--s360-icon-blue)"/></Link>
        }
    }
}

export const TableActionIconView = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: '10px'}}
                            placement='top' text={props.text} icon="icon-view" color="var(--s360-icon-green)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: '10px'}}><IconTooltip placement='top' text={props.text}
                                                                                   icon="icon-components"
                                                                                   color="var(--s360-icon-green)"/></Link>
        }
    }
}

export const TableActionIconDelete = ( props ) =>
{
    if ( props.onClick !== null && props.onClick !== undefined )
    {
        return <IconTooltip onClick={props.onClick} style={{marginRight: '10px'}}
                            placement='top' text={props.text} icon="icon-trash" color="var(--s360-icon-red)"/>
    }
    else
    {
        if ( props.to !== null && props.to !== undefined )
        {
            return  <Link to={props.to} style={{marginRight: '10px'}}><IconTooltip placement='top' text={props.text}
                                                                                   icon="icon-trash"
                                                                                   color="var(--s360-icon-red)"/></Link>
        }
    }
}